// extracted by css-extract-rspack-plugin
export default {"container":"container-DsMZWh","overlayModal":"overlayModal-OniDJR","content":"content-EAqvAU","modalFooter":"modalFooter-UJP2g4"};